import ModelViewerContainer from "./ModelViewerContainer";

export default ModelViewerContainer;
